// extracted by mini-css-extract-plugin
module.exports = {"formError":"FormError_formError__EaZvY","icon":"FormError_icon__zy3_N","rotation":"FormError_rotation__SI7y9"};